import { apiSaveSector, apiUpdateSector } from "scripts/api/sector";
import { detectorControls, folderDropdown, state } from "scripts/app";
import { MessageToast } from "scripts/ui/components/toast";
import { isTourComplete, tourData } from "scripts/ui/tour/tour";

export class SaveControls {
    btn: HTMLButtonElement;
    modal: HTMLElement;
    detectorNameInput: HTMLInputElement;
    confirmSaveBtn: HTMLButtonElement;
    cancelSaveBtn: HTMLButtonElement;
    modalTitle: HTMLSpanElement;
        
        constructor(){
            // Кнопка сохранения
            const btn = document.getElementById('saveBtn');
            // Модальное окно
            const modal = document.getElementById('saveSectorModal');
            const detectorNameInput = document.getElementById('sectorNameInput');
            const confirmSaveBtn = document.getElementById('confirmSaveSectorBtn');
            const cancelSaveBtn = document.getElementById('cancelSaveSectorBtn');
            const modalTitle = document.getElementById('save-sector-modal-title');

            if (
                !(btn instanceof HTMLButtonElement) ||
                !(modal instanceof HTMLElement) ||
                !(detectorNameInput instanceof HTMLInputElement) ||
                !(confirmSaveBtn instanceof HTMLButtonElement) ||
                !(cancelSaveBtn instanceof HTMLButtonElement) ||
                !(modalTitle instanceof HTMLSpanElement)
            ) {
                throw new Error("Элемент сохранения сектора не найден");
            }

            this.btn = btn;
            this.modal = modal;
            this.detectorNameInput = detectorNameInput;
            this.confirmSaveBtn = confirmSaveBtn;
            this.cancelSaveBtn = cancelSaveBtn;
            this.modalTitle = modalTitle;

            this.addEventListener();
        }

        /**
         * Блокируем кнопку
         */
        public setDisable() {
            this.btn.disabled = true;
        }
        public setEnable() {
            this.btn.disabled = false;
        }
    
        private addEventListener(){
            this.btn.addEventListener('click', () => this.openModal());
            this.confirmSaveBtn.addEventListener('click', () => this.confirmModal());
            this.cancelSaveBtn.addEventListener('click', () => this.closeModal());
        }
    
        private openModal(){
            // Меняем заголовок модального окна
            if (state.detector?.id && state.detector?.id != "temp"){
                this.modalTitle.innerText = "Перезаписать датчик";
            } else {
                this.modalTitle.innerText="Сохранить датчик";
            }
            // Если редактируем сектор - в поле вставляем его название
            this.detectorNameInput.value = state.detector?.name ?? '';
            
            this.modal.style.display = 'block';
            // Фокусируемся на поле ввода
            this.detectorNameInput.focus();
        }

        private closeModal(){
            this.modal.style.display = 'none';
        }

        private async confirmModal(){
            // Получаем название сектора
                const name = this.detectorNameInput.value.trim();
                if (!name) { MessageToast.showDanger('save', 'Введите название датчика'); return;}
                if (!state.detector) { MessageToast.showDanger('save', 'Сначала выберите или создайте датчик'); return;}
                
                try {
                    // Если пользователь обновляет старый сектор
                    if (state.detector?.id != "temp"){
                        // ОБНОВЛЕНИЕ СЕКТОРА
                        state.detector.name = name;
                        const updatedDetector = await apiUpdateSector(state.detector);
                        if(!updatedDetector) {MessageToast.showDanger('2', 'Не удалось сохранить датчик'); return;}

                        // Обновляем точки в выпадающих списках
                        await folderDropdown.detectorDropdown.loadMenu();
                        
                        state.resetDetector = null;
                        state.detector = updatedDetector;
                        folderDropdown.detectorDropdown.setSelect(state.detector.id);

                        detectorControls.coords.setCoords(state.detector?.lat, state.detector?.lng);
                        detectorControls.coords.setAzimuth(null);
                        

                        MessageToast.show("3", `Сектор "${name}" успешно перезаписан.`);
                        
                    } else {
                        // СОЗДАНИЕ НОВОГО СЕКТОРА
                        const newSector = await apiSaveSector(name, state);
                        
                        if (newSector && newSector.id) {
            
                            // При прохождении тура добавляем id сектора
                            if(!isTourComplete()){
                                tourData.sectorId = newSector.id;
                            }
                            state.detector.removeGraphics();
                            state.detector = newSector;
                            
                            // Обновляем точки в выпадающих списках
                            await folderDropdown.detectorDropdown.loadMenu();
                            folderDropdown.detectorDropdown.setSelect(newSector.id);
            
                            MessageToast.show("3", `Сектор "${name}" успешно создан.`);
                        } else {
                            throw new Error('Ошибка создания датчика');
                        }
                        
                        // Обновляем точки в выпадающих списках
                        if (state.folder){
                            // await refreshPointDropdown(state.folder?.id);
                        }
                        
                        const sectorDropdownElem = document.querySelector(`.ui-dropdown-sector-${newSector.id}`) as HTMLHtmlElement;
                        if(sectorDropdownElem){
                            // onPointSelect(newSector, sectorDropdownElem);
                        }
                    }
                    // Скрываем модальное окно
                    this.closeModal();
                    detectorControls.start.setEnable();
            
                } catch (error) {
                    console.error('Ошибка создания сектора:', error);
                }
        }
}